import lazyLoading from './lazyLoading'

export default {
  name: 'CategoriesFetcher',
  path: '/categories_fetcher',
  hidden: true,
  component: lazyLoading('categoriesFetcher', true),
  meta: {
    auth: true,
    label: 'Categories Fetcher',
    expanded: false
  }
}
